import * as React from "react";
import { cn } from "@/lib/utils";

export interface PageHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

/**
 * PageHeader component for consistent page titles.
 * Uses standardized text-xl font-normal pattern.
 * 
 * When used with flex layouts (e.g. justify-between), title and subtitle
 * stay grouped together on the left, while children appear on the right.
 */
export function PageHeader({ title, subtitle, className, children, ...props }: PageHeaderProps) {
  return (
    <div className={cn("flex-shrink-0 mb-6", className)} {...props}>
      <div className="flex-1">
        <h1 className="text-xl font-normal">{title}</h1>
        {subtitle && (
          <p className="text-sm text-muted-foreground mt-2">{subtitle}</p>
        )}
      </div>
      {children}
    </div>
  );
}



